/*
<summary>
   This higher-order component is all about wrapping a component with Import Defective Items popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 05-Oct-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

const ImportDefectiveItemPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showImportPopup, setShowImportPopup] = useState<boolean>(false);

    const importToggleHandler = () => {
      setShowImportPopup(!showImportPopup);
    };

    return (
      <Component
        showImportPopup={showImportPopup}
        importToggleHandler={importToggleHandler}
        {...props}
      />
    );
  };

export default ImportDefectiveItemPopupHOC;
